import React from "react";
import ontLogo from "../../../../assets/img/ont-logo.svg";

export default function Logo() {
    return <div className="footer__logo">
        <img src={ontLogo} alt="Oxford Nanopore Technologies"/>
    </div>;
}
